module.exports = __webpack_public_path__ + "img/business-solutions-hero.73ec320f.png";